module.exports = __webpack_public_path__ + "static/media/sword-laser.7494ed98.svg";